import { ReactNode } from 'react';
import './PostItNote.css';

export type PostItPosition = 'top-left' | 'top-right' | 'top-center' | 'bottom-left' | 'bottom-right' | 'center';
export type PointerDirection = 'button-area' | 'mode-selector' | null;

interface PostItNoteProps {
  message: string | ReactNode;
  position: PostItPosition;
  pointerTo?: PointerDirection;
  onNext?: () => void;
  onSkip?: () => void;
  showNextButton?: boolean;
  showSkipButton?: boolean;
}

export const PostItNote = ({
  message,
  position,
  pointerTo = null,
  onNext,
  onSkip,
  showNextButton = false,
  showSkipButton = false,
}: PostItNoteProps) => {
  const getPositionClass = () => {
    switch (position) {
      case 'top-left':
        return 'post-it-top-left';
      case 'top-right':
        return 'post-it-top-right';
      case 'top-center':
        return 'post-it-top-center';
      case 'bottom-left':
        return 'post-it-bottom-left';
      case 'bottom-right':
        return 'post-it-bottom-right';
      case 'center':
        return 'post-it-center';
      default:
        return 'post-it-top-center';
    }
  };

  const getPointerClass = () => {
    if (!pointerTo) return '';
    switch (pointerTo) {
      case 'button-area':
        return 'post-it-pointer-down';
      case 'mode-selector':
        return 'post-it-pointer-down';
      default:
        return '';
    }
  };

  return (
    <div className={`post-it-note ${getPositionClass()}`}>
      <div className="post-it-content">
        {typeof message === 'string' ? <p>{message}</p> : message}
      </div>

      {pointerTo && <div className={`post-it-pointer ${getPointerClass()}`} />}

      {(showNextButton || showSkipButton) && (
        <div className="post-it-buttons">
          {showSkipButton && onSkip && (
            <button className="post-it-btn post-it-btn-skip" onClick={onSkip}>
              Saltar
            </button>
          )}
          {showNextButton && onNext && (
            <button className="post-it-btn post-it-btn-next" onClick={onNext}>
              Siguiente →
            </button>
          )}
        </div>
      )}
    </div>
  );
};
